export default __webpack_public_path__ + "static/media/payment_exist.131ef6bf.svg";